module.exports = __webpack_public_path__ + "assets/img/closeLandmarkIcon.bf230c11.png";